import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import '../../../stylesheets/pages/components/ThemeSwatches.less';
import { updateCurrentTheme, storeCurrentThemeKey } from '../../../actions/website/ThemeActions';

class ThemeSwatches extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      currentTheme: props.currentTheme,
    };
  }

  onSwatchClickHandler(theme, localThemeGroupKey) {
    const { sendCurrentTheme, storeThemeKey } = this.props;
    const themeKey = theme.key;
    this.props.onSwatchClick(theme);
    this.setState({
      active: !this.state.active
    });
    sendCurrentTheme(theme);
    storeThemeKey(themeKey, localThemeGroupKey);
  }

  isSelected(theme) {
    const { currentTheme } = this.props;
    return theme.id === currentTheme.id;
  }

  render() {
    const { themeOptions, pageName } = this.props;
    const swatches = [];
    const swatchOptions = themeOptions.themes;
    if (swatchOptions) {
      swatchOptions.map(themes => (
        swatches.push(
          (
            <div className={['swatch-container', this.isSelected(themes) ? 'active' : null].join(' ')} onClick={() => { this.onSwatchClickHandler(themes, themeOptions.themes[0].key); }} key={themes.id}>
              <div className="swatch-inner-container" key={themes.id} style={{ backgroundColor: `#${themes.swatch_color_1}` }}>
                <div className="swatches">
                  <div className="swatch-one" style={{ backgroundColor: `#${themes.swatch_color_1}` }} />
                  <div className="swatch-two" style={{ backgroundColor: `#${themes.swatch_color_2}` }} />
                </div>
              </div>
            </div>
          )
        )
      ));
    }

    return (
      <div>
        <div>
          { pageName === 'theme-detail'
            && <div className="all-swatches">{swatches}</div>
          }
        </div>
        <div>
          { pageName === 'themes'
          && (
          <div>
            <div className="hidden-xs"><div className="all-swatches">{swatches}</div></div>
            { swatches.length > 1
              && <div className="visible-xs mobile-swatches">{swatches.length} colors</div>
            }
          </div>
          )
          }
        </div>
      </div>
    );
  }
}
ThemeSwatches.propTypes = {
  currentTheme: PropTypes.shape({}),
  themeOptions: PropTypes.shape({
    themes: PropTypes.arrayOf(
      PropTypes.shape({})
    ),
  }),
  onSwatchClick: PropTypes.func.isRequired,
  sendCurrentTheme: PropTypes.func,
  storeThemeKey: PropTypes.func,
  pageName: PropTypes.string
};

const mapStateToProps = state => (
  {
    currentSwatch: state.website.themeListing.currentTheme.theme,
  }
);

const mapDispatchToProps = dispatch => (
  {
    sendCurrentTheme: theme => dispatch(updateCurrentTheme(theme)),
    storeThemeKey: (themeKey, localThemeGroupKey) => dispatch(storeCurrentThemeKey(themeKey, localThemeGroupKey)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThemeSwatches);



// WEBPACK FOOTER //
// ./src/components/manage/website/ThemeSwatches.jsx